export default {
    changePassword:{
       name: 'Change Password',
       class:'button button-3'
    },
    apiKey: {
        name: 'API Key',
        class:'button button-3'

    },
    refreshToken:{
        name:'Refresh Token',
        class:'button button-3'

    }
}